<template>
  <hypto-popup :title="currentTitle" :footer="false" css="width-lg">
    <template v-slot:body>
      <div class="actions">
        <button
          v-if="webhooksAllowed && !['PENDING', 'REFUND_PENDING'].includes(collection.status)"
          class="primary-btn"
          @click="resendWebhook"
        >
          Resend Webhook
          <i class="fa fa-paper-plane" />
        </button>

        <button v-if="manageAccess.collection && ['COMPLETED', 'REFUND_FAILED'].includes(collection.status)"
            class="dark-btn"
            @click="initiateRefund()">
          Refund
          <i class="fa fa-redo" />
        </button>
      </div>

      <div v-for="(data, index) in details" :key="index" class="details-row">
        <h6>{{data.field}}</h6>

        <p v-if="data.value">
          {{data.value}}
          <i
            v-if="data.field === 'Status' && ['PENDING', 'REFUND_PENDING'].includes(data.value)"
            class="fa fa-sync-alt"
            @click="pendingStatus($event)"
          />
        </p>
        <p v-else-if="data.link">
          <u @click="changeData(data.link)">{{data.link}}</u>
          <i>(Click to view details)</i>
        </p>
      </div>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'

import ApiServices from '@/services/api/upiCollections'
import { openPopup } from '@/utils/helpers'

export default {
  name: 'CollectionDetails',
  components: { HyptoPopup },
  data () {
    return {
      details: [],
      allDetails: [],
      currentTitle: null
    }
  },
  props: {
    collection: Object,
    webhooksAllowed: Boolean,
    manageAccess: Object
  },
  watch: {
    collection: {
      handler: 'populateData',
      immediate: true
    }
  },
  methods: {
    openPopup,
    createTxnParams (field, type) {
      if (this.collection[type]) {
        return {
          field: field,
          link: this.collection[type].id
        }
      }
    },
    populateData () {
      this.details = this.collection.popup
      let txn = this.createTxnParams('Completed Transaction ID', 'payment')
      this.addTxnInCollection(txn)
      txn = this.createTxnParams('Reversal Transaction ID', 'revision')
      this.addTxnInCollection(txn)

      this.currentTitle = `Collection - ${this.collection.order_id}`
      this.allDetails = [
        {
          id: this.collection.order_id,
          title: `Collection - ${this.collection.order_id}`,
          details: this.details
        }
      ]
      this.appendTxnDetails('payment')
      this.appendTxnDetails('revision')
    },
    addTxnInCollection (txn) {
      if (txn !== undefined) {
        this.details = [
          ...this.details,
          txn
        ]
      }
    },
    appendTxnDetails (type) {
      if (this.collection[type]) {
        let txn = {...this.collection[type]}
        txn.title = `Transaction ID - ${txn.id}`
        let appendTxn = null
        if (type === 'payment') {
          appendTxn = this.createTxnParams('Reversal Transaction ID', 'revision')
        } else {
          appendTxn = this.createTxnParams('Completed Transaction ID', 'payment')
        }

        txn.details = [
          ...txn.details,
          {
            field: 'Collection Order ID',
            link: this.collection.order_id
          }
        ]
        if (appendTxn) {
          txn.details = txn.details.concat(appendTxn)
        }
        txn.details = txn.details.filter(e => e !== undefined)
        this.allDetails.push(txn)
      }
    },
    changeData (id) {
      const current = this.allDetails.find(e => e.id === id)
      this.details = current.details
      this.currentTitle = current.title
    },
    pendingStatus (event) {
      this.$emit('refreshCollection', event, this.collection, true)
    },
    resendWebhook () {
      ApiServices.resendWebhook(this.collection.id).then(response => {
        response.success ? this.successToastMsg(response.message) : this.errorToastMsg(response.message)
      })
    },
    initiateRefund () {
      this.openPopup('RefundConfirmation')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/mixins.scss';

  .actions {
    text-align: left;

    button {
      margin-bottom: 10px;

      i {
        margin-left: 10px;
      }
    }
  }

  .details-row {
    display: flex;
    margin: 5px 0;

    h6 {
      @include normal-text($grey-text, 13px, 500);
      width: 45%;
      text-align: left;
      margin-right: 10px;
    }
    p {
      @include highlight-text($secondary, 13px);
      text-align: left;
      max-width: 52%;

      u {
        color: $primary;
        margin-right: 5px;
        cursor: pointer;
      }
      i {
        color: $grey-light;
      }
    }
    .fa-sync-alt {
      color: $primary;
      margin: 0 5px;
      cursor: pointer;
    }
  }

  .desktop {
    .actions {
      button {
        min-width: 170px;
      }
    }
  }

  .tablet, .mobile {
    .actions {
      button {
        width: 48%;
      }
    }
  }

  .mobile {
    .actions {
      button {
        font-size: 12px;
        padding: 10px 5px !important;
      }
    }
  }
</style>
